$(document).ready(function () {
  console.log("Launched builder script!");

  $(".pp_var_qty_adjust").click(function () {
    var variantId = $(this).attr("data-variant");
    var qty = parseFloat(
      $(this).closest(".pp_builder_var_qty").find(".pp_var_qty_value").html()
    );
    var mode = $(this).attr("data-mode");
    if (mode == "plus") {
      qty++;
    } else if (mode == "minus") {
      if (qty > 0) {
        qty--;
      }
    }
    $(this).closest(".pp_builder_var_qty").find(".pp_var_qty_value").html(qty);
    if (qty > 0) {
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_adjust.minus")
        .css("opacity", "1");
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_value")
        .css("opacity", "1");
      $(this).closest(".pp_builder_var_qty").addClass("hasItem");
    } else {
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_adjust.minus")
        .css("opacity", "0");
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_value")
        .css("opacity", "0");
      $(this).closest(".pp_builder_var_qty").removeClass("hasItem");
    }

    setVariantContent(variantId);
    calculateTotalItems();
  });

  function setVariantContent(variantId) {
    $(".pp_img_main_var_img__js").addClass("hiddenImg");
    $('.pp_img_main_var_img__js[data-id="' + variantId + '"]').removeClass(
      "hiddenImg"
    );
  }

  function calculateTotalItems() {
    var totalItems = 0;
    $(".pp_builder_var_qty").each(function () {
      var thisQuantity = parseFloat($(this).find(".pp_var_qty_value").html());
      totalItems += thisQuantity;
    });

    var currency = String($(".pp_bundle_pricing").attr("data-currency"));
    currency = currency.replace("00", "").replace("0", "");

    console.log(totalItems, "TOTAL ITEMS IN BUILDER");
    if (totalItems == 0) {
      $(".ppb_progress_img").hide();
      $('.ppb_progress_img[data="0"]').show();
      $(".pp_bundle_pricing").each(function () {
        var price = $(this).attr("data-price");
        var compPrice = $(this).attr("data-compare-price");
        var totalPrice = (0).toFixed(2);
        var totalComparePrice = (0).toFixed(2);

        var discount = parseFloat(totalComparePrice) - parseFloat(totalPrice);
        var discount = (discount * 100) / parseFloat(totalComparePrice);
        discount = Math.round(discount);

        $(this)
          .find(".pp_bundle_price__real")
          .html(currency + totalPrice);
        $(this)
          .find(".pp_bundle_price__comp")
          .html(currency + totalComparePrice);
        $(this)
          .find(".pp_bundle_price_badge")
          .html(discount + "% Off");
        if ($(this).hasClass("otpPricing")) {
          $(".pp_bundle_price_otp").html(currency + totalPrice);
        } else {
          $(".pp_bundle_price_sub").html(currency + totalPrice);
        }

        $(this).find(".pp_bundle_price_badge").hide();
        $(this).find(".pp_bundle_price__comp").hide();
      });
    } else if (totalItems >= 1 && totalItems < 3) {
      $(".ppb_progress_img").hide();
      $('.ppb_progress_img[data="' + totalItems + '"]').show();
      $(".pp_bundle_pricing").each(function () {
        var price = $(this).attr("data-price");
        var compPrice = $(this).attr("data-compare-price");
        var totalPrice = ((price * totalItems) / 100).toFixed(2);
        var totalComparePrice = ((compPrice * totalItems) / 100).toFixed(2);

        var discount = parseFloat(totalComparePrice) - parseFloat(totalPrice);
        var discount = (discount * 100) / parseFloat(totalComparePrice);
        discount = Math.round(discount);

        $(this)
          .find(".pp_bundle_price__real")
          .html(currency + totalPrice);
        $(this)
          .find(".pp_bundle_price__comp")
          .html(currency + totalComparePrice);
        $(this)
          .find(".pp_bundle_price_badge")
          .html(discount + "% Off");
        if ($(this).hasClass("otpPricing")) {
          $(".pp_bundle_price_otp").html(currency + totalPrice);
        } else {
          $(".pp_bundle_price_sub").html(currency + totalPrice);
        }
        $(this).find(".pp_bundle_price_badge").hide();
        $(this).find(".pp_bundle_price__comp").hide();
      });
    } else if (totalItems >= 3 && totalItems < 5) {
      $(".ppb_progress_img").hide();
      $('.ppb_progress_img[data="' + totalItems + '"]').show();
      $(".pp_bundle_pricing").each(function () {
        var price = $(this).attr("data-price");
        var compPrice = $(this).attr("data-compare-price");
        var totalPrice = ((price * (totalItems - 1)) / 100).toFixed(2);
        var totalComparePrice = ((compPrice * totalItems) / 100).toFixed(2);

        var discount = parseFloat(totalComparePrice) - parseFloat(totalPrice);
        var discount = (discount * 100) / parseFloat(totalComparePrice);
        discount = Math.round(discount);

        $(this)
          .find(".pp_bundle_price__real")
          .html(currency + totalPrice);
        $(this)
          .find(".pp_bundle_price__comp")
          .html(currency + totalComparePrice);
        $(this)
          .find(".pp_bundle_price_badge")
          .html(discount + "% Off");
        if ($(this).hasClass("otpPricing")) {
          $(".pp_bundle_price_otp").html(currency + totalPrice);
        } else {
          $(".pp_bundle_price_sub").html(currency + totalPrice);
        }
        $(this).find(".pp_bundle_price_badge").show();
        $(this).find(".pp_bundle_price__comp").show();
      });
    } else if (totalItems >= 5 && totalItems < 7) {
      $(".ppb_progress_img").hide();
      $('.ppb_progress_img[data="' + totalItems + '"]').show();
      $(".pp_bundle_pricing").each(function () {
        var price = $(this).attr("data-price");
        var compPrice = $(this).attr("data-compare-price");
        var totalPrice = ((price * (totalItems - 2)) / 100).toFixed(2);
        var totalComparePrice = ((compPrice * totalItems) / 100).toFixed(2);

        var discount = parseFloat(totalComparePrice) - parseFloat(totalPrice);
        var discount = (discount * 100) / parseFloat(totalComparePrice);
        discount = Math.round(discount);

        $(this)
          .find(".pp_bundle_price__real")
          .html(currency + totalPrice);
        $(this)
          .find(".pp_bundle_price__comp")
          .html(currency + totalComparePrice);
        $(this)
          .find(".pp_bundle_price_badge")
          .html(discount + "% Off");
        if ($(this).hasClass("otpPricing")) {
          $(".pp_bundle_price_otp").html(currency + totalPrice);
        } else {
          $(".pp_bundle_price_sub").html(currency + totalPrice);
        }
      });
    } else if (totalItems >= 7) {
      $(".ppb_progress_img").hide();
      $('.ppb_progress_img[data="7"]').show();
      $(".pp_bundle_pricing").each(function () {
        var price = $(this).attr("data-price");
        var compPrice = $(this).attr("data-compare-price");
        var totalPrice = ((price * (totalItems - 3)) / 100).toFixed(2);
        var totalComparePrice = ((compPrice * totalItems) / 100).toFixed(2);

        var discount = parseFloat(totalComparePrice) - parseFloat(totalPrice);
        var discount = (discount * 100) / parseFloat(totalComparePrice);
        discount = Math.round(discount);

        $(this)
          .find(".pp_bundle_price__real")
          .html(currency + totalPrice);
        $(this)
          .find(".pp_bundle_price__comp")
          .html(currency + totalComparePrice);
        $(this)
          .find(".pp_bundle_price_badge")
          .html(discount + "% Off");
        if ($(this).hasClass("otpPricing")) {
          $(".pp_bundle_price_otp").html(currency + totalPrice);
        } else {
          $(".pp_bundle_price_sub").html(currency + totalPrice);
        }
      });
    }
  }

  $(".pp_builder_mode_freq_box").click(function () {
    $(".pp_builder_mode_freq_box").removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_builder_mode_box").click(function () {
    $(".pp_builder_mode_box").removeClass("active");
    $(this).addClass("active");

    var mode = $(this).attr("data");
    if (mode == "sub") {
      $(".pp_sub_gifts_box").show();
    } else {
      $(".pp_sub_gifts_box").hide();
    }
  });

  $(document).scroll(function () {
    if ($(document).scrollTop() >= 700) {
      $(".ppb_outer.sticky_bar").addClass("active");
    } else {
      $(".ppb_outer.sticky_bar").removeClass("active");
    }
  });

  $(".pp_bundle_option").click(function () {
    $(".pp_bundle_option").removeClass("pp_bundle_selected");
    $(this).addClass("pp_bundle_selected");
    var mode = $(this).attr("mode");

    if (mode == "sub") {
      $(".pp_bundle_pricing").addClass("hidded");
      $(".pp_bundle_pricing.subPricing").removeClass("hidded");
    } else {
      $(".pp_bundle_pricing").addClass("hidded");
      $(".pp_bundle_pricing.otpPricing").removeClass("hidded");
    }
  });

  $(function () {
    const days = ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date();
    date.setDate(date.getDate() + 4);

    const day = days[date.getDay()];
    const month = months[date.getMonth()];
    const dayNum = date.getDate();

    const formattedDate = `${day} ${month}, ${dayNum}`;

    $(".pp_timeline_date").text(formattedDate);
  });

  $(".pp_bundle_freq_selection").change(function () {
    var currentLoop = $(this).val();
    $(".pp_builder_var_qty").each(function () {
      var newId = $(this)
        .find('.pp_freq_selection__js[data-loop="' + currentLoop + '"]')
        .attr("data-id");
      $(this).attr("data-selling-plan", newId);
    });
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.pp_bundle_option[mode="otp"]').find("input").trigger("click");
    } else {
      $('.pp_bundle_option[mode="sub"]').find("input").trigger("click");
    }
  });
});
